import React, { FC, useEffect, useRef, useState } from 'react'
import { ArticleHeroPillarProps } from './ArticleHeroPillar.types'
import { PillarBoxColor } from './PillarBoxColor.types'
import { ImageCompound } from '../../ImageCompound'
import { RTECompound } from '../../RTECompound'

export const ArticleHeroPillar: FC<ArticleHeroPillarProps> = props => {
  const { header, description, image, boxColor, headerColor, shouldGrow } = props
  const testId = props.testId
  const [marginLeft, setMarginLeft] = useState(0)
  const [imgWidth, setImgWidth] = useState(0)
  const bgColorDivRef = useRef<HTMLDivElement>(null)

  const pillarBoxClassNames = [
    'ArticleHeroPillar-box',
    'u-flex',
    'u-lg-size5of12',
    'u-md-size5of12',
    'u-paddingTop32',
    'u-paddingBottom32',
    'u-paddingLeft20',
    'u-paddingRight20',
  ]
  const headerClassNames = []
  let backgroundColor: string

  useEffect(() => {
    updateMargin()
    window.addEventListener('resize', updateMargin)
    return () => {
      window.removeEventListener('resize', updateMargin)
    }
  })

  const updateMargin = () => {
    if (bgColorDivRef.current) {
      setMarginLeft(bgColorDivRef.current.offsetWidth - 75)
      setImgWidth(bgColorDivRef.current.offsetWidth - 75)
    }
  }

  switch (boxColor) {
    case PillarBoxColor.DARK_MINT:
      pillarBoxClassNames.push('u-bgColorDarkMint')
      backgroundColor =
        'linear-gradient(90deg, rgba(222, 238, 239, 1) 85%, rgba(247, 245, 248, 0) 100%)'
      break
    case PillarBoxColor.BERRY:
      pillarBoxClassNames.push('u-bgColorBerry')
      backgroundColor =
        'linear-gradient(90deg, rgba(243, 242, 241, 1) 85%, rgba(247, 245, 248, 0) 100%)'
      break
    case PillarBoxColor.MINT:
      pillarBoxClassNames.push('u-bgColorMint')
      backgroundColor =
        'linear-gradient(90deg, rgba(222, 238, 239, 1) 85%, rgba(247, 245, 248, 0) 100%)'
      break
    case PillarBoxColor.MIDNIGHT_BLUE:
      pillarBoxClassNames.push('u-bgColorMidnightBlue')
      backgroundColor =
        'linear-gradient(90deg, rgba(243, 242, 241, 1) 85%, rgba(247, 245, 248, 0) 100%)'
      break
    case PillarBoxColor.ORANGE:
      pillarBoxClassNames.push('u-bgColorOrange')
      backgroundColor =
        'linear-gradient(90deg, rgba(243, 242, 241, 1) 85%, rgba(247, 245, 248, 0) 100%)'
      break
    case PillarBoxColor.LIME_LIGHT:
      pillarBoxClassNames.push('u-bgColorData7')
      backgroundColor =
        'linear-gradient(90deg, rgba(242, 247, 221, 1) 85%, rgba(247, 245, 248, 0) 100%)'
      break
    case PillarBoxColor.LIGHT_BLUE:
      pillarBoxClassNames.push('u-bgColorLightBlue')
      backgroundColor =
        'linear-gradient(90deg, rgba(243, 242, 241, 1) 85%, rgba(247, 245, 248, 0) 100%)'
      break
    case PillarBoxColor.PURPLE:
    default:
      pillarBoxClassNames.push('u-bgColorPurple')
      backgroundColor =
        'linear-gradient(90deg, rgba(235, 232, 238, 1) 85%, rgba(247, 245, 248, 0) 100%)'
  }

  switch (headerColor) {
    case 'neutral':
      headerClassNames.push('u-textColorNeutral')
      break
    case 'white':
    default:
      headerClassNames.push('u-textColorWhite')
  }

  return (
    <>
      <style
        type='text/css'
        dangerouslySetInnerHTML={{
          __html: `
         .artiBackground {background: ${backgroundColor}}
         .articleMargin {margin-left: ${marginLeft}px}
         .articleWidth {width: calc(100% - ${imgWidth}px)}
      `,
        }}
      />
      <section className={`ArticleHeroPillar${shouldGrow ? ' u-flexGrow' : ''}`}>
        <div className='ArticleHeroPillar-container u-posRelative u-paddingBottom20 u-sm-flex u-sm-flexColReverse'>
          <div
            className={pillarBoxClassNames.join(' ')}
            data-testid={testId ? `${testId}-box` : null}
          >
            <h1
              className={headerClassNames.join(' ') + ' hero-pillar-heading'}
              data-testid={testId ? `${testId}-box-header` : null}
            >
              {header}
            </h1>
          </div>
          <div
            className='artiBackground ArticleHeroPillar-background u-flex u-lg-size4of12 u-md-size4of12 u-sm-hidden'
            ref={bgColorDivRef}
          ></div>
          <div className='ArticleHeroPillar-image-container u-sm-hidden articleMargin articleWidth'>
            <div
              className='ArticleHeroPillar--featuredImage u-sizeFull'
              data-testid={testId ? `${testId}-image` : null}
            >
              <ImageCompound {...image} imagePosition='full' />
            </div>
          </div>
          <div className='ArticleHeroPillar--mobileFeaturedImage u-lg-hidden u-md-hidden'>
            <ImageCompound {...image} imagePosition='full' />
          </div>
        </div>
        {description && description.content && (
          <div className='ArticleHeroPillar-description u-lg-size8of12 u-md-size8of12 u-paddingBottom20'>
            <RTECompound {...description} />
          </div>
        )}
      </section>
    </>
  )
}
